module.exports = __webpack_public_path__ + "media/assets/icons/pagenavicon_ranking-9e26116543c46fc171592f06546575fd.svg";